// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./css/components/_decorative.scss
// module id = 37
// module chunks = 0